import { render } from "./CountBadge.vue?vue&type=template&id=036854fc&scoped=true"
import script from "./CountBadge.vue?vue&type=script&lang=js"
export * from "./CountBadge.vue?vue&type=script&lang=js"

import "./CountBadge.vue?vue&type=style&index=0&id=036854fc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036854fc"]])

export default __exports__